"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The TouchpointReq model module.
 * @module model/TouchpointReq
 * @version 1.0.0
 */
var TouchpointReq = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>TouchpointReq</code>.
   * @alias module:model/TouchpointReq
   */
  function TouchpointReq() {
    _classCallCheck(this, TouchpointReq);

    TouchpointReq.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(TouchpointReq, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>TouchpointReq</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TouchpointReq} obj Optional instance to populate.
     * @return {module:model/TouchpointReq} The populated <code>TouchpointReq</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new TouchpointReq();

        if (data.hasOwnProperty('title')) {
          obj['title'] = _ApiClient.default.convertToType(data['title'], 'String');
        }

        if (data.hasOwnProperty('date')) {
          obj['date'] = _ApiClient.default.convertToType(data['date'], 'String');
        }

        if (data.hasOwnProperty('category')) {
          obj['category'] = _ApiClient.default.convertToType(data['category'], 'String');
        }

        if (data.hasOwnProperty('duration')) {
          obj['duration'] = _ApiClient.default.convertToType(data['duration'], 'String');
        }

        if (data.hasOwnProperty('services_provided')) {
          obj['services_provided'] = _ApiClient.default.convertToType(data['services_provided'], 'String');
        }

        if (data.hasOwnProperty('notes')) {
          obj['notes'] = _ApiClient.default.convertToType(data['notes'], 'String');
        }

        if (data.hasOwnProperty('survivor_id')) {
          obj['survivor_id'] = _ApiClient.default.convertToType(data['survivor_id'], 'Number');
        }
      }

      return obj;
    }
  }]);

  return TouchpointReq;
}();
/**
 * @member {String} title
 */


TouchpointReq.prototype['title'] = undefined;
/**
 * @member {String} date
 */

TouchpointReq.prototype['date'] = undefined;
/**
 * @member {String} category
 */

TouchpointReq.prototype['category'] = undefined;
/**
 * @member {String} duration
 */

TouchpointReq.prototype['duration'] = undefined;
/**
 * @member {String} services_provided
 */

TouchpointReq.prototype['services_provided'] = undefined;
/**
 * @member {String} notes
 */

TouchpointReq.prototype['notes'] = undefined;
/**
 * @member {Number} survivor_id
 */

TouchpointReq.prototype['survivor_id'] = undefined;
var _default = TouchpointReq;
exports.default = _default;